import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { DOMAIN_IN_CART_SPEC, cartSupportedTlds } from '../../constants/eligibility';
import { DomainAvailabilityStatus } from '../../typing';
import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const isEligibleForDomainInCart = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    msid,
    domainName
  } = request;
  const {
    biLogger,
    referralAdditionalInfo,
    panorama
  } = getPremiumEssentialsSafe() ?? {};
  try {
    var _experimentsResponse$;
    const {
      domainAvailability,
      domainsAccount,
      experiments
    } = await dynamicLoadApiQueries(httpClient);
    const {
      tld,
      subdomain,
      formattedInput
    } = parseDomain(domainName);
    if (!cartSupportedTlds.has(tld) || subdomain || !msid) {
      return {
        isEligible: false
      };
    }
    const [{
      status,
      premium: isPremiumDomain
    }, {
      isPremiumSite,
      isSiteBelongsToAccount,
      hasAmountDiscountCoupons
    }, experimentsResponse] = await Promise.all([domainAvailability({
      domainName: formattedInput
    }), domainsAccount({
      msid
    }), experiments({
      experiments: [DOMAIN_IN_CART_SPEC]
    })]);
    const isDomainInCartEnabled = !!((_experimentsResponse$ = experimentsResponse.experiments) != null && _experimentsResponse$[DOMAIN_IN_CART_SPEC]);
    const isAvailableForPurchase = status.includes(DomainAvailabilityStatus.AVAILABLE_FOR_PURCHASE);
    const isEligible = Boolean(isAvailableForPurchase && !isPremiumDomain && isPremiumSite && !hasAmountDiscountCoupons && isSiteBelongsToAccount);
    if (isEligible && biLogger) {
      const {
        domainPurchaseFlowCartExposureSrc17Evid885
      } = await import('@wix/bi-logger-premium-data-domains/v2');
      biLogger.report(domainPurchaseFlowCartExposureSrc17Evid885({
        domain: domainName,
        isCartActive: isDomainInCartEnabled,
        msid,
        referralAdditionalInfo
      }));
    }
    return {
      isEligible: isEligible && isDomainInCartEnabled
    };
  } catch (error) {
    panorama == null || panorama.errorMonitor().reportError(error);
    return {
      isEligible: false
    };
  }
};
//# sourceMappingURL=isEligibleForDomainInCart.js.map